import React from 'react';
import { CompleteKundali, Language, ChartStyle } from '../../types/kundali';
import { Grantha1_JanmaGanita } from './Grantha1_JanmaGanita';
import { Grantha2_Shodashvarga } from './Grantha2_Shodashvarga';
import { Grantha3_BalaAshtakavarga } from './Grantha3_BalaAshtakavarga';
import { Grantha4_MultiDasha } from './Grantha4_MultiDasha';
import { Grantha5_Phaladesh } from './Grantha5_Phaladesh';
import { Grantha6_LalKitab } from './Grantha6_LalKitab';
import { Grantha7_Varshaphala } from './Grantha7_Varshaphala';
import { Grantha8_GemologyMuhurta } from './Grantha8_GemologyMuhurta';

import { AstrologerBranding } from '../../lib/astrologerBrandingService';

export interface GranthaPagesProps {
  kundali: CompleteKundali;
  lang: Language;
  isBw: boolean;
  pageBorder: string;
  runningHeaderBorder: string;
  headingPrimary: string;
  headingAccent: string;
  innerCardBg: string;
  tableBorder: string;
  tableHeaderBg: string;
  tableRowEven: string;
  tableRowOdd: string;
  mutedText: string;
  renderPageFooter: (label: string) => React.ReactNode;
  activeGrantha?: number | 'ALL';
  chartStyle?: ChartStyle;
  branding?: AstrologerBranding;
}

export const GranthaPages: React.FC<GranthaPagesProps> = (props) => {
  const { activeGrantha = 'ALL' } = props;

  return (
    <>
      {/* Grantha 1: Janma Ganita, Ephemeris, KP & Coordinates (Pages 1–6) */}
      {(activeGrantha === 'ALL' || activeGrantha === 1) && (
        <Grantha1_JanmaGanita {...props} />
      )}

      {/* Grantha 2: Mandalas & Complete Shodashvarga Geometry (Pages 7–14) */}
      {(activeGrantha === 'ALL' || activeGrantha === 2) && (
        <Grantha2_Shodashvarga {...props} />
      )}

      {/* Grantha 3: Shadbala, Bhava Bala & Ashtakavarga Matrices (Pages 15–22) */}
      {(activeGrantha === 'ALL' || activeGrantha === 3) && (
        <Grantha3_BalaAshtakavarga {...props} />
      )}

      {/* Grantha 4: The Multi-Dasha Mahachakra (All 7 Systems) (Pages 23–32) */}
      {(activeGrantha === 'ALL' || activeGrantha === 4) && (
        <Grantha4_MultiDasha {...props} />
      )}

      {/* Grantha 5: Shastric Phaladesh (9 Planets & 12 Bhavas) (Pages 33–42) */}
      {(activeGrantha === 'ALL' || activeGrantha === 5) && (
        <Grantha5_Phaladesh {...props} />
      )}

      {/* Grantha 6: Lal Kitab 7 Debts, Farmans & 43-Day Totkes (Pages 43–47) */}
      {(activeGrantha === 'ALL' || activeGrantha === 6) && (
        <Grantha6_LalKitab {...props} />
      )}

      {/* Grantha 7: 20-Year Longitudinal Varshaphala 2025–2044 (Pages 48–52) */}
      {(activeGrantha === 'ALL' || activeGrantha === 7) && (
        <Grantha7_Varshaphala {...props} />
      )}

      {/* Grantha 8: Consecrated Gemology, Classical Yogas & Colophon (Pages 53–56) */}
      {(activeGrantha === 'ALL' || activeGrantha === 8) && (
        <Grantha8_GemologyMuhurta {...props} />
      )}
    </>
  );
};
